var Numbers = (() => {
    var _this;

    _this = {
		getSign: function(number, ignorePlus) {
			number = parseFloat(number);

			if (isNaN(number)) {
				return '';
			}

			if (number > 0.0) {
				return ignorePlus ? '' : '+';
			}

			if (number < 0.0) {
				return '-';
			}

			return '±';
		},
        calculateMatches: function(value) {
            return (Math.pow((value-1), 2) + (value-1)) / 2;
        },
        calculateNextBase2: function(value) {
            return Math.pow(2, Math.ceil(Math.log2(value)));
        },
		floatToString: function(value, precision, separator, roundingFunc) {
			var valueString, rounded, sign;
			if (!separator) {
				separator = ',';
			}
			separator = String(separator);
			precision = parseInt(precision, 10);
			if (isNaN(precision) || (precision < 0)) {
				precision = 0;
			}
			if (!roundingFunc) {
				roundingFunc = 'round';
			}
			rounded = Math[roundingFunc](parseFloat(value) * Math.pow(10, precision));
			sign = (rounded < 0) ? '-' : '';
			valueString = String(Math.abs(rounded)).padStart(precision + 1, '0');
			return `${sign}${valueString.substring(0, valueString.length - precision)}${(precision > 0) ? `${separator}${valueString.substring(valueString.length - precision)}` : ''}`;
		}
    };

    return _this;
})();